<script setup>
    import _ from 'lodash'
    import navItems from '@/navigation/index'
    import adminNavItems from '@/navigation/admin'
    import {
        themeConfig
    } from '@themeConfig'

    // Components
    import Footer from '@/layouts/components/Footer.vue'
    import UserProfile from '@/layouts/components/UserProfile.vue'
    import NavBarI18n from '@core/components/I18n.vue'
    import {
        HorizontalNavLayout
    } from '@layouts'
    import pageLogo from '@images/logo.png'

    // --------------- 👉 User Pinia Store
    import {
        useStore
    } from '@/stores/user'
    const userStore = useStore()
    // --------------- 👉 User Pinia Store
    const featureKeys = userStore.featureKeys
    const roles = userStore.roles

    const navList = computed(() => {
        if (_.includes(userStore.roles, 'distributor_admin') || _.includes(userStore.roles, 'distributor_hr')) {
            return _.concat(navItems, adminNavItems)
        } else {
            return navItems
        }
    })
</script>

<template>
    <HorizontalNavLayout :nav-items="navList">
        <!-- 👉 navbar -->
        <template #navbar>
            <NuxtLink to="/" class="d-flex align-start gap-x-4">
                <img :src="$siteLogo()" class="page-logo-style">
            </NuxtLink>
            <VSpacer />

            <NavBarI18n v-if="themeConfig.app.i18n.enable && themeConfig.app.i18n.langConfig?.length"
                :languages="themeConfig.app.i18n.langConfig" />

            <!-- <NavbarThemeSwitcher class="me-2" /> -->
            <UserProfile />
        </template>


        <!-- 👉 Pages -->
        <slot />

        <!-- 👉 Footer -->
        <template #footer>
            <Footer />
        </template>

        <!-- 👉 Customizer -->
        <!-- <TheCustomizer /> -->
    </HorizontalNavLayout>
</template>